// extracted by mini-css-extract-plugin
export var chevron = "_m5-3";
export var chevronRotated = "_m5-4";
export var image = "_m5-1";
export var imageContainer = "_m5-0";
export var shippingAddress = "_m5-2";